import { Vue, Component } from 'vue-property-decorator';


@Component({})
export default class EditViewMixin extends Vue {
    public isEditing: boolean = false;

    public startEditing(): void {
        this.isEditing = true;
    }

    public cancelEditing(): void {
        this.isEditing = false;
    }

    public saveEditing(): void {
        this.isEditing = false;
    }
}
